import CircularProgress from 'components/CircularProgress';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import PageNotFound from 'routes/Errors/PageNotFound';

import { ITransactionTabsProps } from '../types';
import CloneTransactionModal from './CloneTransactionModal';
import TransactionForm from './TransactionForm';

const TransactionDetailTab: React.FC<ITransactionTabsProps> = ({
  transactionData,
  transactionLoading,
  transactionTypesData,
  userDataLoading,
  userPermittedLocationsData,
  refetchTransactionData,
  refetchChatRoomData,
  fetchNextPageLocationData,
}) => {
  const [cloneModalVisible, setModalVisible] = useState(false);
  const [cloneTransactionId, setCloneTransactionId] = useState<string>();
  const history = useHistory();
  const params: Record<string, string> = useParams();
  const transactionIdFromParams = params?.id;
  const transactionId = transactionIdFromParams || cloneTransactionId || history.location.state || '';

  const closeCloneTransactionModal = () => {
    setModalVisible(false);
  };
  const onCloneClick = (transId: string) => {
    setCloneTransactionId(transId);
    closeCloneTransactionModal();
  };

  const isLoading = !transactionId ? false : transactionLoading;

  if (!transactionData) {
    if (!isLoading && !!transactionId) {
      return <PageNotFound />;
    }
    if ((isLoading || userDataLoading) && !!transactionId) {
      return <CircularProgress />;
    }
  }

  const refetchDataWhenTransactionUpdate = () => {
    refetchChatRoomData?.();
    refetchTransactionData?.();
  };

  return (
    <>
      <CloneTransactionModal
        onCloneClick={onCloneClick}
        onClose={closeCloneTransactionModal}
        visible={cloneModalVisible}
      />
      <div className='transaction-content-wrapper'>
        <TransactionForm
          data={transactionData}
          transactionTypesData={transactionTypesData}
          refetchTransactionData={refetchDataWhenTransactionUpdate}
          transactionTypeLoading={userDataLoading}
          userPermittedLocationsData={userPermittedLocationsData}
          fetchNextPageLocationData={fetchNextPageLocationData}
        />
        {/* {!isTransactionEditable && (
          <TransactionDetailOnly
            showSubmitButton={role !== RoleEnum.ADMIN && transactionData?.status === TransactionStatusEnum.MATCHED}
            refetchTransactionData={refetch}
            data={transactionData}
          />
        )} */}
      </div>
    </>
  );
};

export default React.memo(TransactionDetailTab);
